import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DataTable, FlexBox, IconButton, Spinner, Tooltip, } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { analytics } from 'app/utils/segment';
import { AppLink } from 'components/appLink';
import styles from './table.module.scss';
const loadingMessage = (_jsxs("div", Object.assign({ className: styles.messageContainer }, { children: [_jsx(Spinner, { className: styles.messageSpinner, size: 32 }), _jsx("div", Object.assign({ className: styles.messageText }, { children: "Loading audio file usage..." }))] })));
const errorMessage = (_jsx("div", Object.assign({ className: styles.messageContainer }, { children: _jsx("div", Object.assign({ className: styles.messageText }, { children: "An error occurred while loading the audio file usage." })) })));
const noAudioFilesMessage = (_jsx("div", Object.assign({ className: styles.messageContainer }, { children: _jsx("div", Object.assign({ className: styles.messageText }, { children: "Audio file is not attached to any workflow." })) })));
const renderLocation = ({ name, active }) => (_jsxs(FlexBox, Object.assign({ alignItems: "center" }, { children: [_jsx("div", { className: classnames(styles.dot, { [styles.active]: active }) }), _jsx("div", Object.assign({ className: styles.name }, { children: name }))] })));
const renderLink = ({ id, type, filename, }) => (_jsxs(Tooltip, Object.assign({ content: "View flow", dark: true }, { children: [id === 'default' && (_jsx(AppLink, Object.assign({ path: "/settings/phone" }, { children: _jsx(IconButton, { icon: "external-link", variant: "tertiary" }) }))), id !== 'default' && (_jsx(AppLink, Object.assign({ path: "/settings/phone/flow/:id", onClick: () => analytics.settingsAudioUsageFlowClicked({ type, filename }), params: { path: { id } } }, { children: _jsx(IconButton, { icon: "external-link", variant: "tertiary" }) })))] })));
export const FileUsagePageTable = ({ type, filename, usage, asyncStatus, }) => {
    if (asyncStatus === 'rejected') {
        return errorMessage;
    }
    if (!usage.length) {
        if (asyncStatus === 'pending') {
            return loadingMessage;
        }
        return noAudioFilesMessage;
    }
    return (_jsx(DataTable, { data: usage, columns: [
            {
                label: 'Location',
                selector: renderLocation,
            },
            {
                style: { width: 1 },
                selector: (data) => renderLink(Object.assign(Object.assign({}, data), { type, filename })),
            },
        ] }));
};
